import React from 'react'
import PropTypes from 'prop-types'
import groupBy from 'lodash/groupBy'
import {Table, Row, Col} from 'reactstrap'

import UserRoleRatesListItem from "./UserRoleRatesListItem";

const UserRoleRatesList = ({data}) => {

    const groupData = groupBy(data, 'date_active')

    console.log('groupData', groupData)

    const dayFinder = (days, dayToFind) => {
        return days.find(day => day.day_value_id === dayToFind)
    }

    return (
        <div className="d-flex flex-column">
            <Table striped>
                <thead>
                    <tr>
                        <td>Monday</td>
                        <td>Tuesday</td>
                        <td>Wednesday</td>
                        <td>Thursday</td>
                        <td>Friday</td>
                        <td>Saturday</td>
                        <td>Sunday</td>
                        <td>Active From Date</td>
                    </tr>
                </thead>
                <tbody>
                {groupData && Object.keys(groupData).map(key => {

                    const days = groupData[key]

                    console.log(dayFinder(days, 1))

                    const formattedDays = {
                        sun: dayFinder(days, 1),
                        mon: dayFinder(days, 2),
                        tue: dayFinder(days, 3),
                        wed: dayFinder(days, 4),
                        thu: dayFinder(days, 5),
                        fri: dayFinder(days, 6),
                        sat: dayFinder(days, 7),
                    }

                    return <UserRoleRatesListItem {...formattedDays} activeFrom={key}/>
                })}
                </tbody>
            </Table>
        </div>
    )

}

UserRoleRatesList.propTypes = {
    data: PropTypes.array
}

export default UserRoleRatesList